import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=507e7a26&lang=pug"
import script from "./Col.vue?vue&type=script&lang=ts"
export * from "./Col.vue?vue&type=script&lang=ts"
import style0 from "./Col.vue?vue&type=style&index=0&id=507e7a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports